import { MenuItem, MenuList, styled } from '@mui/material';

import { colorPrimary } from '../../../../../styles/mui/colors';

export const SearchList = styled(MenuList)(() => ({
  overflowX: 'hidden',
  overflowY: 'auto',
}));

export const SearchListItem = styled(MenuItem)(() => ({
  '&.Mui-selected': {
    '&:focus-within': { backgroundColor: colorPrimary[200] },
    '&:hover': { backgroundColor: colorPrimary[100] },
    backgroundColor: colorPrimary[50],
    gap: 'var(--spacing-tiny)',
  },
  '&:focus-visible': {
    boxShadow: 'none',
  },
}));

export const SearchListItemText = styled('p')(() => ({
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 'var(--preference-button-line-clamp)',
  display: '-webkit-box',
  overflow: 'hidden',
  textWrap: 'wrap',
}));
